import { Skeleton } from '@nest/uikit-react';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';

export default function ConsignmentNotesScanPackagePage() {
	const client = useTerminalClient();
	const [code, setCode] = useState<string>('');

	const scanQuery = useQuery({
		queryKey: ['consignment-notes', 'scan-package', code],
		queryFn: () => client.consignmentNotes.scanPackageUnitInfoQuery.execute({ code }),
		enabled: false
	});

	const result = useMemo(() => scanQuery.data ?? null, [scanQuery.data]);

	return (
		<TerminalScreen showBackButton topBar={<div>Naskenovat balík</div>}>
			<div className="p-2 flex flex-col gap-3">
				<form
					onSubmit={e => {
						e.preventDefault();
						if (code && code.trim().length > 0) {
							scanQuery.refetch();
						}
					}}
				>
					<input
						type="text"
						className="w-full border rounded p-2"
						placeholder="Naskenujte / zadejte číslo balíku"
						value={code}
						onChange={e => setCode(e.target.value)}
						autoFocus
					/>
				</form>

				{scanQuery.isFetching ? (
					<div className="space-y-2">
						<Skeleton className="h-6 w-full" />
						<Skeleton className="h-6 w-2/3" />
					</div>
				) : result ? (
					<div className="border rounded p-3">
						<div className="font-medium mb-1">Výsledek</div>
						<div>Balík: {result.parcelNumber ?? result.consignmentNumber ?? '-'}</div>
						<div>Příjemce: {result.recipientName ?? '-'}</div>
						<div>Dopravní služba: {result.carrierName ?? '-'}</div>
						<div>Zabalen: {result.packedAt ? new Date(result.packedAt).toLocaleString() : '-'}</div>
						<div>Balící linka: {result.packedByMachineName ?? '-'}</div>
						<div>Dok: {result.packingLineDockLocationName ?? '-'}</div>
						<div>Naskenován do kontejneru: {result.scannedAt ? new Date(result.scannedAt).toLocaleString() : 'ne'}</div>

						{result.containerNumber ? <div>Kontejner: {result.containerNumber}</div> : ''}
					</div>
				) : scanQuery.isFetched ? (
					<div className="p-6 text-center text-muted-foreground">Nenalezeno</div>
				) : null}
			</div>
		</TerminalScreen>
	);
}
